import React, { useContext, Fragment, useEffect } from "react";
import { LandingPageContext } from "../LandingPageContext";
import Pesquisar from "../../../../../Components/Cadastro/Pesquisar/Pesquisar";
import TabelaResultados from "../../../../../Components/Cadastro/TabelaResultados/TabelaResultados";

const PesquisarLandingPage = () => {
  const { values, setValues, resetScreen } = useContext(LandingPageContext);

  useEffect(() => {
    resetScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onChangeInput(event) {
    const { name, value } = event.target;
    setValues({
      ...values,
      searchData: {
        ...values.searchData,
        [name]: value,
      },
    });
  }

  return (
    <Fragment>
      <Pesquisar context={LandingPageContext}>
        <div className="col-12 col-md-2">
          <label>Código</label>
          <input
            className="form-control"
            type="text"
            name="landingPageCod"
            value={values.searchData.landingPageCod}
            onChange={onChangeInput}
          />
        </div>

        <div className="col-12 col-md-4">
          <label>Nome</label>
          <input
            className="form-control"
            type="text"
            name="landingPageNome"
            value={values.searchData.landingPageNome}
            onChange={onChangeInput}
          />
        </div>
      </Pesquisar>
      <TabelaResultados context={LandingPageContext} />
    </Fragment>
  );
};

export default PesquisarLandingPage;
